import React, { useEffect, useMemo, useState } from "react";
import { Backdrop, Card, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useGetAllCommissionsLogsQuery } from "../../redux/Slices/commissionsApi";
import { useMaterialUIController } from "context";
import RTLDataGrid from "components/styled-component/RTLDataGrid";

const LogsSection = () => {
  const [page, setPage] = useState(0);
  const { data: logs, isLoading } = useGetAllCommissionsLogsQuery({ page: page + 1 });
  const [, dispatch] = useMaterialUIController();
  // extract columns data for DataGrid
  const columns = useMemo(
    () => [
      {
        field: "order_commission_id",
        headerName: "معرف العمولة",

        width: 70,
        disableColumnMenu: true,
      },
      {
        field: "is_paid",
        headerName: "حالة الدفع",

        width: 100,
        disableColumnMenu: true,
        renderCell: (params) => (
          <span
            style={{
              color: params.value ? "#4caf50" : "#f44336",
              fontWeight: "bold",
            }}
          >
            {params.value ? "مدفوع" : "غير مدفوع"}
          </span>
        ),
      },
      {
        field: "calculated_commission",
        headerName: "العمولة المحسوبة",

        width: 140,
        disableColumnMenu: true,
        renderCell: (params) => `${params.value || 0} ر.س`,
      },
      {
        field: "base_amount",
        headerName: "المبلغ الأساسي",

        width: 130,
        disableColumnMenu: true,
        renderCell: (params) => `${params.value || 0} ر.س`,
      },
      {
        field: "order_id",
        headerName: "معرف الطلب",

        width: 120,
        disableColumnMenu: true,
      },

      {
        field: "changed_by",
        headerName: "تم التغيير بواسطة",

        width: 150,
        disableColumnMenu: true,
        renderCell: (params) => params.value || "نظام",
      },
      {
        field: "changed_at",
        headerName: "تاريخ التغيير",

        width: 160,
        disableColumnMenu: true,
        renderCell: (params) => {
          if (!params.value) return "-";
          const date = new Date(params.value);
          return date.toLocaleDateString("ar-SA", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          });
        },
      },
      {
        field: "notes",
        headerName: "الملاحظات",

        width: 200,
        disableColumnMenu: true,
      },
      {
        field: "new_value",
        headerName: "القيمة الجديدة",

        width: 120,
        disableColumnMenu: true,
      },
      {
        field: "old_value",
        headerName: "القيمة القديمة",

        width: 120,
        disableColumnMenu: true,
        renderCell: (params) => params.value || "-",
      },
      {
        field: "action",
        headerName: "الإجراء",

        width: 120,
        disableColumnMenu: true,
        renderCell: (params) => {
          const actionMap = {
            created: "إنشاء",
            paid: "مدفوع",
            updated: "تحديث",
            cancelled: "ملغي",
          };
          return actionMap[params.value] || params.value;
        },
      },
    ],
    []
  );

  // Transform the nested data structure to flat structure for DataGrid
  const transformedRows = useMemo(() => {
    if (!logs?.data || !Array.isArray(logs.data)) {
      return [];
    }

    return logs.data.map((log) => ({
      id: log.id,
      action: log.action,
      old_value: log.old_value,
      new_value: log.new_value,
      notes: log.notes,
      changed_at: log.changed_at,
      changed_by: log.changed_by?.name,
      // Flatten order_commission data
      order_commission_id: log.order_commission?.id,
      order_id: log.order_commission?.order_id,
      base_amount: log.order_commission?.base_amount,
      calculated_commission: log.order_commission?.calculated_commission,
      is_paid: log.order_commission?.is_paid,
    }));
  }, [logs?.data]);

  return (
    <>
      <Backdrop open={isLoading} sx={{ zIndex: 2000, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              تفاصيل العمولات
            </MDTypography>
          </MDBox>
          <MDBox p={2}>
            {isLoading ? null : transformedRows.length === 0 ? (
              <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <MDTypography variant="body2" color="text.secondary">
                  لا توجد سجلات متاحة
                </MDTypography>
              </MDBox>
            ) : (
              /* { <DataGrid
                autoHeight
                direction="rtl"
                isRowSelectable={() => false}
                rows={transformedRows}
                columns={columns}
                loading={isLoading}
                disableColumnMenu

                hideFooterSelectedRowCount
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                      page: 0
                    }
                  }
                }}
                pageSizeOptions={[10, 25, 50]}
                onPaginationModelChange={({ page }) => setPage(page)}
                rowCount={logs?.total || 0}
                paginationMode="server"
                localeText={{
                  // Pagination
                  MuiTablePagination: {
                    labelRowsPerPage: 'صفوف في الصفحة:',
                    labelDisplayedRows: ({ from, to, count }) =>
                      `${from}–${to} من ${count !== -1 ? count : `أكثر من ${to}`}`,
                  },
                  // Toolbar
                  toolbarDensity: 'الكثافة',
                  toolbarDensityLabel: 'الكثافة',
                  toolbarDensityCompact: 'مضغوط',
                  toolbarDensityStandard: 'عادي',
                  toolbarDensityComfortable: 'مريح',
                  toolbarColumns: 'الأعمدة',
                  toolbarColumnsLabel: 'اختر الأعمدة',
                  toolbarFilters: 'المرشحات',
                  toolbarFiltersLabel: 'إظهار المرشحات',
                  toolbarFiltersTooltipHide: 'إخفاء المرشحات',
                  toolbarFiltersTooltipShow: 'إظهار المرشحات',
                  toolbarExport: 'تصدير',
                  toolbarExportLabel: 'تصدير',
                  toolbarExportCSV: 'تحميل كـ CSV',
                  toolbarExportPrint: 'طباعة',
                  // Columns panel
                  columnsPanelTextFieldLabel: 'البحث في العمود',
                  columnsPanelTextFieldPlaceholder: 'عنوان العمود',
                  columnsPanelDragIconLabel: 'إعادة ترتيب العمود',
                  columnsPanelShowAllButton: 'إظهار الكل',
                  columnsPanelHideAllButton: 'إخفاء الكل',
                  // Filter panel
                  filterPanelAddFilter: 'إضافة مرشح',
                  filterPanelDeleteIconLabel: 'حذف',
                  filterPanelLinkOperator: 'المشغل المنطقي',
                  filterPanelOperators: 'المشغل',
                  filterPanelOperatorAnd: 'و',
                  filterPanelOperatorOr: 'أو',
                  filterPanelColumns: 'الأعمدة',
                  filterPanelInputLabel: 'القيمة',
                  filterPanelInputPlaceholder: 'قيمة المرشح',
                  // Filter operators
                  filterOperatorContains: 'يحتوي',
                  filterOperatorEquals: 'يساوي',
                  filterOperatorStartsWith: 'يبدأ بـ',
                  filterOperatorEndsWith: 'ينتهي بـ',
                  filterOperatorIs: 'يساوي',
                  filterOperatorNot: 'لا يساوي',
                  filterOperatorAfter: 'بعد',
                  filterOperatorOnOrAfter: 'في أو بعد',
                  filterOperatorBefore: 'قبل',
                  filterOperatorOnOrBefore: 'في أو قبل',
                  filterOperatorIsEmpty: 'فارغ',
                  filterOperatorIsNotEmpty: 'غير فارغ',
                  filterOperatorIsAnyOf: 'أي من',
                  // Column menu
                  columnMenuLabel: 'القائمة',
                  columnMenuShowColumns: 'إظهار الأعمدة',
                  columnMenuFilter: 'مرشح',
                  columnMenuHideColumn: 'إخفاء',
                  columnMenuUnsort: 'إلغاء الترتيب',
                  columnMenuSortAsc: 'ترتيب تصاعدي',
                  columnMenuSortDesc: 'ترتيب تنازلي',
                  // Column header
                  columnHeaderFiltersTooltipActive: (count) =>
                    count !== 1 ? `${count} مرشحات نشطة` : `${count} مرشح نشط`,
                  columnHeaderFiltersLabel: 'إظهار المرشحات',
                  columnHeaderSortIconLabel: 'ترتيب',
                  // Rows selected footer text
                  footerRowSelected: (count) =>
                    count !== 1
                      ? `${count.toLocaleString()} صفوف محددة`
                      : `${count.toLocaleString()} صف محدد`,
                  // Total row amount footer text
                  footerTotalRows: 'إجمالي الصفوف:',
                  // Total visible row amount footer text
                  footerTotalVisibleRows: (visibleCount, totalCount) =>
                    `${visibleCount.toLocaleString()} من ${totalCount.toLocaleString()}`,
                  // Checkbox selection text
                  checkboxSelectionHeaderName: 'تحديد خانة الاختيار',
                  checkboxSelectionSelectAllRows: 'تحديد كل الصفوف',
                  checkboxSelectionUnselectAllRows: 'إلغاء تحديد كل الصفوف',
                  checkboxSelectionSelectRow: 'تحديد الصف',
                  checkboxSelectionUnselectRow: 'إلغاء تحديد الصف',
                  // Boolean cell text
                  booleanCellTrueLabel: 'نعم',
                  booleanCellFalseLabel: 'لا',
                  // Actions cell more text
                  actionsCellMore: 'المزيد',
                  // Column pinning text
                  pinToLeft: 'تثبيت على اليسار',
                  pinToRight: 'تثبيت على اليمين',
                  unpin: 'إلغاء التثبيت',
                  // Tree Data
                  treeDataGroupingHeaderName: 'المجموعة',
                  treeDataExpand: 'عرض الأطفال',
                  treeDataCollapse: 'إخفاء الأطفال',
                  // Grouping columns
                  groupingColumnHeaderName: 'المجموعة',
                  groupColumn: (name) => `تجميع حسب ${name}`,
                  unGroupColumn: (name) => `توقف عن التجميع حسب ${name}`,
                  // Master/detail
                  detailPanelToggle: 'تبديل لوحة التفاصيل',
                  expandDetailPanel: 'توسيع',
                  collapseDetailPanel: 'طي',
                  // Row reordering text
                  rowReorderingHeaderName: 'إعادة ترتيب الصفوف',
                  // Aggregation
                  aggregationMenuItemHeader: 'التجميع',
                  aggregationFunctionLabelSum: 'المجموع',
                  aggregationFunctionLabelAvg: 'المتوسط',
                  aggregationFunctionLabelMin: 'الأدنى',
                  aggregationFunctionLabelMax: 'الأعلى',
                  aggregationFunctionLabelSize: 'الحجم',
                }}
                sx={{
                  '& .MuiDataGrid-root': {
                    fontSize: '0.875rem',
                  },
                  '& .MuiDataGrid-cell': {
                    fontSize: '0.875rem',
                    padding: '8px 16px',
                    alignItems: "right"
                  },

                  '& .MuiDataGrid-virtualScrollerRenderZone': {
                    direction: "rtl"
                  },
                  '& .MuiDataGrid-columnHeader': {
                    fontSize: '0.875rem',
                    fontWeight: 'bold',
                    padding: '8px 16px',
                    backgroundColor: '#f5f5f5',
                  },
                  '& .MuiDataGrid-row:hover': {
                    backgroundColor: '#f9f9f9',
                  },
                  '& .MuiDataGrid-selectedRowCount': {
                    display: 'none',
                  },
                }}
              /> */
              <RTLDataGrid
                rows={transformedRows}
                columns={columns}
                onShow={() => {}}
                onUpdate={() => {}}
                onDelete={() => {}}
                onActive={() => {}}
              />
            )}
            {/* 
             <DataTable
              table={{ columns, rows: logs?.last_page }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={true}
              noEndBorder
              sx={{
                "& .MuiTable-root": { minWidth: 1000 },
                "& .MuiTableCell-root": {
                  py: 1.5,
                  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                },
                "& .MuiTableHead-root": {
                  backgroundColor: (theme) => theme.palette.grey[100],
                },
              }}
            /> */}
          </MDBox>
        </Card>
      </MDBox>
    </>
  );
};

export default LogsSection;
